import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { AuthState, OktaAuth } from '@okta/okta-auth-js';
import { filter, map, Observable, take } from 'rxjs';
import { ComponentServices } from './shared/services/component-services';
import { ModalHistoryService } from './core/services/modal-history.service';
import { LaunchDarklyService } from './core/services/launch-darkly.service';
import { RootScopeService } from './core/services/root-scope.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'RelayNavigator';
  public isAuthenticated$!: Observable<boolean>;

  constructor(private _router: Router, private _oktaStateService: OktaAuthStateService, @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth,
    private _services: ComponentServices, modalHistory: ModalHistoryService,
    private _ldService: LaunchDarklyService, private _rootScope: RootScopeService) {
    modalHistory.init();
  }

  /**
   * A page restored by back/forward skips its constructor, which is where pages register for
   * customer switching, so register it again here.
   */
  public onPageRestored(component: any): void {
    if (component?.switchCustomer) {
      this._services.activeComponent = component;
    }
  }


  public async ngOnInit() {
    this.isAuthenticated$ = await this._oktaStateService.authState$.pipe(
      filter((s: AuthState) => !!s),
      map((s: AuthState) => s.isAuthenticated ?? false)
    );

    // A reload skips the login flow, so restart LaunchDarkly for a restored session. Not awaited:
    // FeatureFlagGuard waits for "ready" itself.
    this._oktaStateService.authState$.pipe(
      filter((s: AuthState) => !!s?.isAuthenticated && !!this._rootScope.globals?.currentUserId),
      take(1)
    ).subscribe(() => { void this._ldService.loadFlags(); });
  }

  public async signIn() : Promise<void> {
    await this._oktaAuth.signInWithRedirect().then(
      _ => this._router.navigate(['/profile'])
    );
  }

  public async signOut(): Promise<void> {
    await this._oktaAuth.signOut();
  }

}
